
import {sendRecordResult} from "@/utils/options";
import {timeRangeOptions} from "@/utils/options";
const dateTypeOptions = [
    {id: 'requestDate', text: '请求时间'},
    {id: 'purchaseDate', text: '订购时间'},
    {id: 'shippingDate', text: '发货时间'},
]
export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '全部结果',
    prop: 'result',
    components: [{
        name: 'gj-select',
        prop: 'result',
        propsData: {
            placeholder: '全部结果',
            options: sendRecordResult
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'requestDate'
}]
